export type Config = {
    hostName: string | undefined,
    restPrefix: string | undefined,
    isPageTrackingEnabled: boolean,
    recaptchaSiteKey: string,
    isDev: boolean
}

export const CONFIG: Config = {
    hostName: process.env.REACT_APP_HOSTNAME,
    restPrefix: process.env.REACT_APP_REST_PREFIX,
    isPageTrackingEnabled: process.env.REACT_APP_ENABLE_PAGE_TRACKING === 'true',
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || "",
    isDev: process.env.NODE_ENV === "development"
}